// Please ensure that the paper.gridSize can divide half the sizes of nodes without any remainder.
// e.g. If node width is 160, then 80 should be dividable by gridSize.
const FlowchartConfig = {
  defaultTitleKey: 'SetTitle',
  baseUnit: 4,
  get bevel() {
    return 2 * this.baseUnit;
  },
  get spacing() {
    return 3.5 * this.baseUnit;
  },
  paper: {
    maxWidth: 2300,
    baseHeight: 640,
    background: '#ffffff',
    gridSize: 10,
    ZOOM_STEP: 0.2,
    ZOOM_MAX: 3,
    ZOOM_MIN: 0.1,
    padding: 250,
  },
  nodeSize: {
    default: {
      width: 120,
      height: 60,
    },
    l: {
      width: 280,
      height: 80,
    },
    m: {
      width: 200,
      height: 80,
    },
    s: {
      width: 120,
      height: 60,
    },
  },
  startNode: {
    size: {
      width: 240,
      height: 80,
    },
    position: {
      x: 40,
      y: 40,
    },
    styles: {
      borderRadius: 12,
      fontSize: 16,
    },
  },
  textBlockNode: {
    zIndex: 2,
    size: {
      width: 320,
      height: 80,
    },
    offsetTop: 10,
    offsetTopWithPadding: 10,
    offsetLeft: 0,
    placeholder: 'NoContent',
    styles: {
      borderRadius: 12,
      borderColor: '#e9e9e9',
      backgroundColor: '#ffffff',
      borderStyle: 'solid',
    },
  },
  selectionBehaviorNode: {
    size: {
      width: 90,
      height: 24,
    },
    styles: {
      borderRadius: 12,
    },
  },
  selectionBehaviorContainer: {
    size: {
      width: 0,
      height: 24,
    },
  },
  decisionNode: {
    size: {
      width: 160,
      height: 80,
    },
  },
  containerNode: {
    minSize: {
      width: 240,
      height: 80,
    },
    size: {
      width: 280,
      height: 80,
    },
    headerSize: {
      width: 240,
      height: 24,
    },
    headerSizeBig: {
      width: 240,
      height: 42,
      padding: 25,
    },
    headerMin: {
      width: 120,
    },
    styles: {
      borderRadius: 8,
      headerBorderRadius: 12,
      headerTextPadding: 10,
      headerNegativePadding: -6,
      selectionBehaviorHorizontalPadding: 16,
      selectionBehaviorVerticalPadding: -6,
    },
    subComponentNode: {
      offset: 60,
      size: {
        width: 200,
        height: 40,
        heightTags: 60,
      },
      styles: {
        verticalPadding: 24,
        verticalPaddingBaseTop: 52,
        verticalPaddingBaseBottom: 20,
        horizontalPadding: 30,
      },
      arrow: {
        width: 12,
        height: 14,
        marginBetweenParent: 10,
        marginBetweenArrows: 4,
      },
    },
  },
  label: {
    top: {
      padding: 35,
    },
  },
  embeddedDescription: {
    padding: {
      labelPadding: 8,
    },
    labelHeight: 50,
  },
  arrow: {
    offset: 8,
    strokeWidth: 8,
    topColor: '#606a70',
    leftColor: '#606a70',
    rightColor: '#606a70',
    bottomColor: '#2196F3',
  },
  plus: {
    offset: 18,
    strokeWidth: 1,
    inactive: '#e9e9e9',
    active: '#063D70',
    inside: '#fff',
  },
  removeButton: {
    offset: 10,
  },
  baseElementDistance: 140,
  actionNode: {
    size: {
      width: 100,
      height: 80,
    },
    styles: {
      borderRadius: 12,
    },
    subflow: {
      buttonHeight: 40,
      buttonOffsetY: 40,
      newYPositionAdjustment: 10,
    },
    strokeColors: {
      diagnostic: '#d0dce7',
      therapeutic: '#89bcea',
    },
  },
  sidebar: {
    minWidth: 300,
    defaultWidth: 350,
    maxWidth: 500,
    contentMinWidth: 800,
  },
  tag: {
    zIndex: 2,
    body: {
      rx: 10,
      ry: 10,
    },
    size: {
      height: 16,
      iconTagHeight: 16,
      iconTagWidth: 14,
      iconHeight: 14,
      iconWidth: 14,
    },
    textWrap: {
      width: -8,
    },
    padding: {
      verticalPadding: 6,
      verticalTextPadding: 12,
      horizontalPaddingStart: 8,
      horizontalPadding: 20,
      paddingBetweenTags: 8,
      paddingBetweenTagsAndLabel: 16,
    },
    parentSizeChangeValues: {
      width: 60,
      height: 20,
    },
    textLength: 10.5,
  },
  replaceButton: {
    size: 48,
    offset: 4,
  },
};

export const LINK_BEND_SIZE = 12;
export const MINIMUM_INCOMING_LINK_LENGTH = 100;

const FontAttributes = {
  fontFamily: "'Roboto', 'Helvetica Neue', sans-serif",
  fontStyle: 'normal',
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 18,
};

const FontAttributesTags = {
  fontSizeTags: 12,
  lineHeightTags: 16,
};

class PlusIcon {
  static generatePlusIcon(circleFill: string, stroke: string, fill: string, id: string) {
    const plusIcon = [
      {
        tagName: 'circle',
        selector: 'icon-background',
        attributes: {
          cx: 0,
          cy: 0,
          r: 10,
          fill: circleFill,
          cursor: 'pointer',
          id: id,
        },
      },
      {
        tagName: 'path',
        selector: 'icon',
        attributes: {
          d: 'M -5 0 L 5 0 M 0 -5 L 0 5',
          stroke: stroke,
          'stroke-width': 2,
          fill: fill,
          cursor: 'pointer',
        },
      },
    ];
    return plusIcon;
  }
}

export { FlowchartConfig, FontAttributes, FontAttributesTags, PlusIcon };
